import { useCallback, useEffect, useState } from "react";
import fetchSdlDataConfig from "../services/FetchesSdlData";

export default function useGetData<T>() {
  const [data, setData] = useState<T[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const refetch = useCallback(async () => {
    setIsError(false);
    setIsLoading(true);
    try {
      const result = await fetchSdlDataConfig();
      setData(result.data.items.edges[0].node.content.data.settings.$values);
    } catch (error) {
      setIsError(true);
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { data, isLoading, isError, refetch };
}
